import React, { useContext, useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import AppBreadCrumb from '../../common/AppBreadCrumb'

import { getUoms } from '../../../api/UomsAPI';
import { createUom, fetchUom, updateUom } from '../../../api/UomsAPI';
import { handleApiError } from '../../../api/risapi';
import AppToaster from '../../AppToaster';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter, replaceHyphenwithSpace } from '../../../commonfunctions';

import { AuthContext } from '../../AuthContext';

const UomsForm = (props) => {

  const { formType, currentUomId } = props;
  const navigate = useNavigate();
  const formRef = useRef(null);
 

  const [currentUom, setCurrentUom] = useState(null);
  const [currentUomError, setCurrentUomError] = useState(null);
  

  const [showToaster, setShowToaster] = useState(false);
  const [toaster, setToaster] = useState({});





  useEffect(() => {

    



  }, []);




  const customStyles = {
    option: (provided, user) => ({
      ...provided,
      color: 'black', // Set label color to black
      backgroundColor: user.isFocused ? '#11a1fd' : 'white', // Blue on hover, white otherwise
      color: user.isFocused ? 'white' : 'black', //White text on blue, black otherwise
      padding: '15',
    }),
    control: (provided) => ({
      ...provided,
      borderColor: 'rgba(98,98,98, 0.4)', // Optional: customize the border
    }),
    singleValue: (provided, Uom) => ({
      ...provided,
      textAlign: 'left', // Align the selected value text to the left
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0.5rem 0.5rem',
    }),

  };


  const saveAddUomForm = (exitForm) => {

    console.log("new Uom is", currentUom);

    setCurrentUomError({});
     
    const saveUom = { ...currentUom };

    createUom(saveUom, function (response) {
      console.log("in createUom", response);

      if ("uom" in response) {


        // setSaveCompleted(prevUom => !prevUom); // Toggle the Uom
        if (exitForm) {

          navigate('/franchisee_user/masters/uoms', {
            state: { message: 'Uom saved successfully!' }
          });
        }
        else {
          setShowToaster(true);
          setToaster({ type: 'success', heading: 'Success', message: 'Uom Added Successfully' });
          setCurrentUom(null);
         
        }
      }
      else {
        // Use the generic error handling function
        console.log("error Response", response);

        handleApiError(response, setCurrentUomError);
      }


    });

  }

  const handleResetUomForm = () => {

    setCurrentUom(null);
    setCurrentUomError(null);
  }

  const getTitle = () => {

    console.log("formType", formType);

    if (formType == 'create') {
      return 'Create New Uom Wizard'
    }
    else {
      return 'Edit Uom Wizard'
    }
  }

  useEffect(() => {
    setCurrentUom(null);

    if (formType != null && formType != 'create' && currentUomId) {

      fetchUom(currentUomId, function (response) {
        console.log("in fetchUom", response);

        if ("uom" in response) {
         
          setCurrentUom(response.uom);
          


        }



      });
    }

  }, [formType, currentUomId]);


  const saveEditUomForm = (exitForm) => {


    setCurrentUomError(null);
    
    const saveUom = { ...currentUom };
    updateUom(currentUom, function (response) {
      console.log("in updateUom", response);

      if ("uom" in response) {

        // setToaster({ type: 'success', heading: 'Success', message: 'Uom Updated Successfully' });
        // setShowToaster(true);
        navigate('/franchisee_user/masters/uoms', {
          state: { message: 'Uom Updated successfully!' }
        });

      }
      else {
        // Use the generic error handling function
        handleApiError(response, setCurrentUomError);
      }


    });
  }







  return (
    <>
      <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster}></AppToaster>
      <main>
        <div className="container-fluid">
          {/* Breadcrumb start */}
          <AppBreadCrumb title={getTitle()}>
            <li>
              <a className="f-s-14 f-w-500" href="#">Masters</a>
            </li>
            <li>
              <a className="f-s-14 f-w-500" href="#">Uom Masters</a>
            </li>
            <li >
              <a className="f-s-14 f-w-500" href="#">Uoms</a>
            </li>
            <li className="active">
              <a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a>
            </li>
          </AppBreadCrumb>


          {/* Breadcrumb end */}
          {/* ready to use form start */}
          <div className="row">
            {/* Book Appointment Form start */}
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5>{formType == 'create' ? 'Add New' : 'Edit'} Uom  {formType == 'edit' ? (':' + currentUom?.name) : ''}</h5>
                </div>
                <div className="card-body">
                  <form className="app-form" >
                    <div className="row">
                    
                      <div className="col-md-12">
                        <div >
                          <label className="form-label"> Name *</label>
                          <input className="form-control"  placeholder="Enter Name" value={currentUom ? currentUom.name : ''} onChange={(e) => setCurrentUom({ ...currentUom, name: e.target.value })} required type="text" />
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentUomError?.name}</span>
                        </div>
                         <div >
                          <label className="form-label"> Short Name *</label>
                          <input className="form-control"  placeholder="Enter Short Name" value={currentUom ? currentUom.short_name : ''} onChange={(e) => setCurrentUom({ ...currentUom, short_name: e.target.value })} required type="text" />
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentUomError?.short_name}</span>
                        </div> 
                        
                      </div>

                     
                      

                    

                    


                      <div className="col-12">
                        <div className="text-end">
                          {formType == 'create' ? (
                            <>
                              <button className="btn btn-outline-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveAddUomForm(0)}>Save + Next
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              <button className="btn btn-primary me-2 btn-sm btn-md " type="button" onClick={() => saveAddUomForm(1)}>Save + Exit
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M11 12H22M11 12L15 8M11 12L15 16" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              <button className="d-none d-md-inline-block btn btn-danger btn-sm btn-md btn-mobile-padding me-2" onClick={handleResetUomForm} type="reset">Reset</button>
                            </>
                          ) : (
                            <>
                              <button className="btn btn-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveEditUomForm(1)}> Update
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              
                            </>
                          )}

                           <button className="d-none  d-md-inline-block btn btn-light-reddit b-r-22 d-inline-flex-center" type="button" onClick={() => navigate('/franchisee_user/masters/uoms')} >Go Back</button>

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Book Appointment Form end */}




          </div>
          {/* ready to use form and */}
        </div>
      </main>

    </>
  )
}

export default UomsForm
